import { createStore } from "owa-satcheljs";
import getInitialSxSViewState from "owa-sxsdata/lib/utils/getInitialSxSViewState";
import type RecentFilesState from "./schema/RecentFilesState";
import type RecentFilesListState from "./schema/RecentFilesListState";

const initialState: RecentFilesState = {
    recentFilesPerGroup: new Map<string, RecentFilesListState>(),
    fileInformation: {},
    sxsState: {
        datapoint: null,
        /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
         * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
         *	> Function getInitialSxSViewState called at module scope is not allowed. This may cause unwanted side effects. */
        viewState: getInitialSxSViewState(),
    },
    shouldShowCallout: false,
    calloutShown: false,
};

export const getRecentFilesStore: () => RecentFilesState = createStore<RecentFilesState>("recentFilesStore", initialState);
